// extracted by mini-css-extract-plugin
module.exports = {"bandeira":"Pagamento_bandeira__T-b6f"};